<template>
    <div class="app-container">
        <div class="div-align-lr page-top-but">
            <div></div>
            <div style="width=250px"><el-input placeholder="请输入内容" v-model="searchPatrolVal" class="input-with-select">
                <el-select v-model="searchPatrolSelectVal" slot="prepend" placeholder="请选择">
                    <el-option label="任务单号" value="order"></el-option>
                    <el-option label="客户姓名" value="u_realname"></el-option>
                    <el-option label="团队负责人" value="t_realname"></el-option>
                    <el-option label="团队名称" value="team"></el-option>
                    <el-option label="项目名称" value="item_name"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="onSearchPatrolBut"></el-button>
            </el-input></div>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" row-key="id" stripe style="width: 100%">
            <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
            <el-table-column align="center" prop="order" label="任务编号"> </el-table-column>
            <el-table-column align="center" prop="name" label="所属团队名称" sortable> </el-table-column>
            <el-table-column align="center" prop="t_realname" label="所属团队负责人" sortable> </el-table-column>
            <el-table-column align="center" prop="item_name" label="所属项目" sortable> </el-table-column>
            <el-table-column align="center" prop="state" label="任务状态" sortable> </el-table-column>
            <el-table-column align="center" prop="create_time" label="创建时间"> </el-table-column>     

            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                <el-button @click="handleClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
            
        <div class="pageWrap">
            <el-pagination background layout="prev, pager, next" :hide-on-single-page="true" :current-page.sync="pageData.current_page" :page-size="pageData.per_page" :total="pageData.total" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import {apiPatrolTaskList} from "../../api/views/allList";
import {formatDate} from "../../utils/rules";
export default {
    data() {
        return {
            pageData: {
                total: 0,
                per_page: 0,
            },
            tableData: [],
            searchPatrolSelectVal: '',
            searchPatrolVal: '',
        }
    },
    mounted() {

    },
    created:function() {
        this.getList({page:1})
    },
    methods: {
        getList(query){
            const stateMap = {
                0: '--',
                1: '新任务',
                2: '进行中',
                3: '更换设备',
                4: '已完成',
            }
            apiPatrolTaskList(query).then(res => {
                console.log(res)
                for(let i of res.data) {
                    i.create_time = formatDate(i.create_time*1000)
                    i.state = stateMap[i.state]
                }
                this.pageData = res
                this.tableData = res.data
            })
        },
        handleCurrentChange: function(currentPage){
            this.getList({page:currentPage})
        },
        handleClick(row) {
            console.log(row)
            this.$router.push({path:'/customer/equipment-details',query:{
                eid: row.equipment.split(',')[0],
                tid: row.id,
                tabname: 'patrol'
            }})
        },
        onSearchPatrolBut(){
            console.log('搜索')
            this.query = {}
            this.query[this.searchPatrolSelectVal] = this.searchPatrolVal
            if(this.searchPatrolSelectVal && this.searchPatrolVal){
                this.getList(this.query)
            }else if(!this.searchPatrolSelectVal){
                this.$message({
                    message: '搜索类型不能为空',
                    type: "error"
                })
            }else if(!this.searchPatrolVal){
                this.$message({
                    message: '搜索内容不能为空',
                    type: "error"
                })
            }
        },
    }
};
</script>

<style lang="scss" scoped>

</style>
